import { render, staticRenderFns } from "./portfolio-panel.vue?vue&type=template&id=97ed2c88"
import script from "./portfolio-panel.ts?vue&type=script&lang=ts&external"
export * from "./portfolio-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./portfolio-panel.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports